import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {fromEvent, Observable, Subscription, timer} from 'rxjs';
import {Store} from '@ngrx/store';
import {selectAuthState} from '../../../../store/app.states';
import { Plugins, AppState } from '@capacitor/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {PatientService} from '../../../../services/patient.service';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {ToolbarService} from '../../../../services/toolbar.service';
import {AttachFileDialogComponent} from '../../../../services/dialogs/attach-file-dialog/attach-file-dialog.component';
import {Platform} from '@ionic/angular';
import {App} from '@capacitor/core';


@Component({
  selector: 'app-patient-chat',
  templateUrl: './patient-chat.component.html',
  styleUrls: ['./patient-chat.component.css']
})
export class PatientChatComponent implements OnInit {

  getAuthState: Observable<any>;
  customState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  message;
  title = 'Chat';
  back = true;
  destination = '/contact-center';
  messages: any[];
  textSend = '';
  isMobile: boolean;
  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  @ViewChild('scrollMe') private myScrollContainer: ElementRef; // importato abbassare la scroll bar.

  constructor(private store: Store<AppState>,
              private dialog: MatDialog,
              private router: Router,
              private patientService: PatientService,
              private toolbarService: ToolbarService,
              private platform: Platform) {
    this.getAuthState = this.store.select(selectAuthState);
  }

  ngOnInit(): void {
    this.subscribeResizeChanges();
    this.subscribeAppStateChange();

    /* Questo eventListener scatena un metodo quando arriva un nuovo messaggio. Quindi aggiorno la pagina*/
    document.addEventListener('new-chat-message', () => {
      this.getChatMessage();
      setTimeout(this.scrollToBottom, 500);
    });

    this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      // Chiedo al server l'elenco dei messaggi già scambiati
      this.getChatMessage();
    });

    /* Nel caso non sia stato dato il permesso di ricevere notifiche aggiorniamo la
       pagina ogni 60 secondi*/
    if (localStorage.getItem('firebase-token') === 'null') {
      console.log('firebase-token non attivo');
      setInterval(() =>  this.getChatMessage(), 60000);
    }
  }

  // Questo metodo permette di controllare se il messaggio da visualizzare è mio (quindi va a destra)
  // oppure è di qualcun'altro (e quindi viene posizionato a sinistra)
  itIsMy(mess: any) {
    const mitt = mess.sender;
    const user = JSON.parse(localStorage.getItem('user'));
    if (mitt === user.email) {
      return true;
    } else {
      return false;
    }
  }

  sendMessage() {
    let textToSend = this.textSend;
    this.textSend = '';
    this.patientService.sendMessage(textToSend).subscribe(newMessage => {
      // l'end point contattato mi restituisce il dto con tutte le informazioni sul messaggio, lo parsifico
      // Aggiungo il messaggio tra quelli della finestra e pulisco il campo dove ho scritto il messaggio.
      this.messages.push(JSON.parse(newMessage.body));
      console.log(this.messages);
      // this.textSend = '';
      this.sleep(200).then(x=>
        this.scrollToBottom()
      );
      }, error => {
      if (error.status === 500) {
        // nel caso di errore 500 vuol dire che è scaduto il token ma noi non ci siamo accorti
        localStorage.setItem('expirationTime', '0');
        console.log('sessione scaduta');
        location.reload();
      }
        // this.openErrorDialog('Il messaggio non è stato mandato per un errore. Se il problema persiste ci contatti via e-mail');
        // this.router.navigateByUrl("/login");
      });
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollToBottom(); // = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }

  getChatMessage() {
    this.patientService.getChatMessages(this.user.email).subscribe(messages => {
      this.messages = messages;
      this.scrollToBottom();
      this.toolbarService.updateMessageUnreadBadge(false);
    }, error => {
      if (error.status === 500) {
        // nel caso di errore 500 vuol dire che è scaduto il token ma noi non ci siamo accorti
        localStorage.setItem('expirationTime', '0');
        console.log('sessione scaduta');
        location.reload();
      }
      // this.openErrorDialog('Qualcosa è andato storto. Se l\'errore persiste ci contatti via e-mail.');
    });
  }

  // metodo che permette di scaricare il file appena cliccato.
  downloadFile(mess: any) {
    this.patientService.getFile(mess.patientEmail, mess.id).subscribe(data => {
      this.saveFile(data, mess.text);
      // apriamo il file in un altra finestra con le seguenti istruzioni.
      /*var fileURL = window.URL.createObjectURL(data);
      let tab = window.open();
      tab.location.href = fileURL;*/
    });
  }

  // Funzione per inviare un file al server.
  attachFile() {
    // Annullo il refresh nel caso si cambi finestra, perché in alcuni browser al ritorno dal caricamento
    // dell'allegato, veniva scatenato l'aggiornamento pagina e si chiudeva la dialog senza poter mandare il file.
    this.unsubscribeAppStateChange();
    // Per prima cosa si apre la dialog che permette di selezionarlo.
    const dialogRef = this.dialog.open(AttachFileDialogComponent, {
      width: '400px',
    });
    // Una volta selezionato, dopo la chiusura della dialog ricevo il file. Se il file è undefined vuol dire che è stato
    // cliccato sul bottone annulla.
    dialogRef.afterClosed().subscribe(file => {
      if (file !== undefined) {
        this.patientService.sendFile(file).subscribe(newMessage => {
          // l'end point contattato mi restituisce il dto con tutte le informazioni sul messaggio.
          // Aggiungo il messaggio tra quelli della finestra e pulisco il campo dove ho scritto il messaggio.
          this.messages.push(newMessage);
          this.scrollToBottom();
        }, error => {
          if (error.status === 500) {
            // In questo caso è molto più problema che l'errore 500 sia stato rilanciato perché il file è troppo grande.
            // localStorage.setItem('expirationTime', '0');
            // console.log('sessione scaduta');
            // location.reload();
            this.openErrorDialog('L\'allegato supera la dimensione massima accettata (15MB).');
          }
        });
      }
      // ristabilisco l'aggiornamento della pagina nel caso si cambi finestra.
      this.subscribeAppStateChange();
    });
  }

  /* Questo metodo permette di iscriversi a un evento che si scatena quando la pagina viene modificata.
  *  Se quindi la pagina diventa troppo piccola viene settato un flag isMobile che ci permette di capire se siamo
  *  su un dispositivo mobile.*/
  subscribeResizeChanges() {
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => {
      if (window.innerWidth < 600) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });

    if (window.innerWidth < 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  unsubscribeResizeChanges() {
    this.resizeSubscription$.unsubscribe();
  }

  subscribeAppStateChange() {
    this.platform.ready().then(() => {
      App.addListener('appStateChange', (state: AppState) => {
        if (state.isActive) {
          console.log('App has become active');
          location.reload();
        }
      });
    });
  }

  unsubscribeAppStateChange() {
    this.platform.ready().then(() => {
      App.removeAllListeners();
    });
  }

  /* permette di scaricare il file */
  saveFile(blob, fileName) {
    let a = document.createElement('a');
    document.body.appendChild(a);
    // @ts-ignore
    a.style = 'display: none';
    // var json = JSON.stringify(data),
    // blob = new Blob([json], {type: "octet/stream"}),
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
